'use strict';

angular.module('atex.dam').controller('DamBudgetViewController', ['$scope', '$q', '$rootScope', '$sce', '$filter', '$timeout', '$window', '$compile', 'ContentService', 'DamTaskService', 'DamNotificationService', 'DamSearchService','ContentConfigurationService', 'configuration',
	function ($scope, $q, $rootScope, $sce, $filter, $timeout, $window, $compile, ContentService, DamTaskService, DamNotificationService, DamSearchService,ContentConfigurationService, configuration) {

		$scope.webStatusList = [];
		$scope.WFStatusList = [];
		$scope.renderedHtml = false;
		$scope.overlayTaskInfo = [];
		$scope.retivingTaskInfo = false;
		$scope.wfStatuspath = "_data/aspects/atex.WFContentStatus/data/status";
		var taskPromises = [];

		var transferInfo = { id: 'atex.WebStatusList' };
		ContentConfigurationService.getConfiguration(transferInfo).then(function(response){
			$scope.webStatusList = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/contentData/data/status');
		});
		transferInfo = {id: 'atex.WFStatusList'};
		ContentConfigurationService.getConfiguration(transferInfo).then(function(response){
			$scope.WFStatusList = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/contentData/data/status');
		});

		$scope.getWFStatusFromId = function (statusID) {
			return $scope.WFStatusList.find(function(status) {
				return status.statusID === statusID;
			});
		};

		$scope.clickOnBudgetItem = function (entry, $event) {
			if (!$scope.retivingTaskInfo){
				$scope.setPreviewingItem(entry,$event);
			}
		};


		$scope.getStatusFromId = function (statusID) {
			return $scope.webStatusList.find(function(status) {
				return status.statusID === statusID;
			});
		};

		$scope.getStatusName = function(statusID) {
			if (statusID === undefined){
				statusID = "draft";
			}
			var status =  $scope.webStatusList.find(function(status) {
				return status.statusID === statusID;
			});
			if (status !== undefined){
				return status.name;
			}else{
				return "";
			}
		};

		$scope.getWfStatusName = function(statusID) {
			if (statusID === undefined){
				statusID = "draft";
			}
			var status =  $scope.WFStatusList.find(function(status) {
				return status.statusID === statusID;
			});
			if (status !== undefined){
				return status.name;
			}else{
				return "";
			}
		};


		$scope.overlayTvVideoInfo = function(response, job){
				if (response.data.aspects['atex.WFContentStatus'] && response.data.aspects['atex.WFContentStatus'].data.status && response.data.aspects['atex.WFContentStatus'].data.status.name){
					job.videoWfStatus = response.data.aspects['atex.WFContentStatus'].data.status.name;
				}else if (response.data.aspects['atex.WFContentStatus'] && response.data.aspects['atex.WFContentStatus'].data.status && response.data.aspects['atex.WFContentStatus'].data.status.statusID){
					job.videoWfStatus = response.data.aspects['atex.WFContentStatus'].data.status.statusID.toUpperCase();
				}
				if (response.data.aspects['atex.WebContentStatus'] && response.data.aspects['atex.WebContentStatus'].data.status && response.data.aspects['atex.WebContentStatus'].data.status.name){
					job.videoWebStatus = response.data.aspects['atex.WebContentStatus'].data.status.name;
				}else if (response.data.aspects['atex.WebContentStatus'] && response.data.aspects['atex.WebContentStatus'].data.status && response.data.aspects['atex.WebContentStatus'].data.status.statusID){
					var statusID = response.data.aspects['atex.WebContentStatus'].data.status.statusID || "draft";
					var webstatus =  $scope.webStatusList.find(function(status) {
						return status.statusID === statusID;
					});
					if (webstatus){
						job.videoWebStatus = webstatus.name;
					}else{
						job.videoWebStatus = "UNPUBLISHED";
					}
				}else{
					job.videoWebStatus = "UNPUBLISHED";
				}
				var headline = job._data.aspects.contentData.data.tvHeadline ? job._data.aspects.contentData.data.tvHeadline : job._data.aspects.contentData.data.headline;
				job._data.aspects.contentData.data.tvHeadline = headline;
				if (response.data.aspects.contentData.data.headline){
					job._data.aspects.contentData.data.tvHeadline = escapeHtml(response.data.aspects.contentData.data.headline);
				}
				if (response.data.aspects.contentData.data.lead){
					job._data.aspects.contentData.data.tvDescription = escapeHtml(response.data.aspects.contentData.data.lead);
				}
		};

		$scope.searchedAuthors = [];
		$scope.overlayTaskInfo = [];
		taskPromises = [];
		$scope.searchedVideo = [];

		$scope.isArticle = function (task) {
			var isArticle = false;
			if (task._data.aspects.contentData.data.objectType === "article") {
				if ("subType" in task._data.aspects.contentData.data ) {
					task._data.aspects.contentData.data.storyType = task._data.aspects.contentData.data.subType.charAt(0).toUpperCase() + task._data.aspects.contentData.data.subType.slice(1);
				}
				isArticle = true;
			}
			return isArticle;
		};

		function getFormattedDate(val){
			var time = new Date().getTime(); // get your number
			var date = new Date(parseInt(val)); // create Date object

			var theyear = date.getFullYear();
			var themonth = date.getMonth() + 1;
			var thetoday = date.getDate();

			return String(themonth).padStart(2, '0') + "/" + String(thetoday).padStart(2, '0') + "/" + theyear;
		}

		function getFormattedTvDate(val){

			var monthNames = ["January", "February", "March", "April", "May", "June",
				"July", "August", "September", "October", "November", "December"
			];

			var date = new Date(parseInt(val));


			return date.toLocaleString('en-us', {weekday:'long'}) + ", " + monthNames[date.getMonth()].substring(0,3) + ". " + date.getDate();
		}

		$scope.isNewSubHead = function (job) {
			$scope.setContentShortCut(job);
			var isNewSubHead = false;
			if (!!job._data.aspects.contentData.data.desk) {
				if ($scope.sort[$("#sortState").val()].label === "Desk" || $scope.sort[$("#sortState").val()].label === "Planning"  || ($scope.sort[$("#sortState").val()].label === "Newsday TV") || $scope.sort[$("#sortState").val()].label === "Segments") { //is desk sort or enterprise sort or multimedia
					if ($scope.subheadIds.indexOf(job.id) > -1) {
						//previously saved id
						isNewSubHead = true;
					} else if ($scope.subheadTypes.indexOf(($scope.sort[$("#sortState").val()].label === "Segments" && job._data.aspects.contentData.data.tvPubDate? getFormattedTvDate(job._data.aspects.contentData.data.tvPubDate) : job._data.aspects.contentData.data.desk)) === -1 && $scope.isPendingJob(job) !== true) {
						//a new desk subhead is found
						$scope.subheadTypes.push(($scope.sort[$("#sortState").val()].label === "Segments" && job._data.aspects.contentData.data.tvPubDate? getFormattedTvDate(job._data.aspects.contentData.data.tvPubDate) : job._data.aspects.contentData.data.desk));
						$scope.subheadIds.push(job.id);
						isNewSubHead = true;
					}
				} else {
					$scope.subheadTypes = [];
					$scope.subheadIds = [];
				}
				if (isNaN(job._data.aspects.contentData.data.desk)) {
					job._data.aspects.contentData.data.deskName = ($scope.sort[$("#sortState").val()].label === "Segments" && job._data.aspects.contentData.data.tvPubDate? getFormattedTvDate(job._data.aspects.contentData.data.tvPubDate) : job._data.aspects.contentData.data.desk);
				} else {
					job._data.aspects.contentData.data.deskName = ($scope.sort[$("#sortState").val()].label === "Segments" && job._data.aspects.contentData.data.tvPubDate? getFormattedTvDate(job._data.aspects.contentData.data.tvPubDate) : $scope.desks[parseInt(job._data.aspects.contentData.data.desk, 10)].label);
				}
			}
			return isNewSubHead;
		};

		$scope.isPrintReady = function (job) {
			var isPrintReady = false;
			if ("_data" in job && "atex.WFContentStatus" in job._data.aspects) {
				if (job._data.aspects["atex.WFContentStatus"].data.status.attributes.indexOf("attr.printready") > -1) {
					isPrintReady = true;
				}
			}
			return isPrintReady;
		};

		$scope.isPublished = function (job) {
			var isPublished = false;
			if (!!job.articleStatus && !!job.articleStatus.status && !!job.articleStatus.status.attributes) {
				if (job.articleStatus.status.attributes.indexOf("attr.online") > -1 || job.articleStatus.status.attributes.indexOf("attr.embargo") > -1) {
					isPublished = true;
				}
			}
			return isPublished;
		};

		$scope.setPublishedLabel = function (job) {
			var labelClass = "status";
			if ($scope.isPublished(job)) {
				labelClass = "status publishedinPast";
				if (!!job.articleData && !!job.articleData.timeState && !!job.articleData.timeState.ontime && (new Date(job.articleData.timeState.ontime) > new Date())) {
					labelClass = "status publishedinFuture";
				}
			}
			return labelClass;
		};

		$scope.isSpecialAttention = function (job) {
			var isSpecialAttention = false;
			if ("specialAttention" in job._data.aspects.contentData.data && job._data.aspects.contentData.data.specialAttention === true) {
				isSpecialAttention = true;
			}
			return isSpecialAttention;
		};

		$scope.isPendingJob = function (job) {
			var isPendingJob = false;
			if ("pendingJob" in job._data.aspects.contentData.data && job._data.aspects.contentData.data.pendingJob === true) {
				isPendingJob = true;
			}
			return isPendingJob;
		};

		$scope.isEnterpriseBudget = function (job) {
			var isEnterpriseBudget = false;
			if ("enterpriseBudget" in job._data.aspects.contentData.data && job._data.aspects.contentData.data.enterpriseBudget === true) {
				isEnterpriseBudget = true;
			}
			return isEnterpriseBudget;
		};

		$scope.isMultimediaBudget = function (job) {
			var isMultimediaBudget = false;
			if ("videoData" in job || "weblinkData" in job) {
				isMultimediaBudget = true;
			}
			return isMultimediaBudget;
		};

		$scope.isVideo = function (task) {
			var isVideo = false;
			if (typeof task !== "undefined" && task._data.aspects.contentData.data.objectType === "video") {
				isVideo = true;
			}
			return isVideo;
		};

		//if video content has been given a name and a status
		$scope.isVideoComplete = function (task) {
			var isVideoComplete = false;
			if ($scope.isVideo(task) && "subType" in task._data.aspects.contentData.data && !!task._data.aspects["atex.WFContentStatus"]) {
				isVideoComplete = true;
				task._data.aspects.contentData.data.videoType = task._data.aspects.contentData.data.subType.charAt(0).toUpperCase() + task._data.aspects.contentData.data.subType.slice(1);
				task._data.aspects.contentData.data.videoStatus = task._data.aspects["atex.WFContentStatus"].data.status.name;
			}
			return isVideoComplete;
		};

		$scope.isCollection = function (task) {
			var isCollection = false;
			if (typeof task !== "undefined" && task._data.aspects.contentData.data.objectType === "collection") {
				isCollection = true;
			}
			return isCollection;
		};

		//if collection has been edited and has both name and status
		$scope.isCollectionComplete = function (task) {
			var isCollectionComplete = false;
			if ($scope.isCollection(task) && "subType" in task._data.aspects.contentData.data && !!task._data.aspects["atex.WFContentStatus"]) {
				isCollectionComplete = true;
				task._data.aspects.contentData.data.collectionType = task._data.aspects.contentData.data.subType.charAt(0).toUpperCase() + task._data.aspects.contentData.data.subType.slice(1);
				task._data.aspects.contentData.data.collectionStatus = task._data.aspects["atex.WFContentStatus"].data.status.name;
			}
			return isCollectionComplete;
		};

		$scope.isWebLink = function (task) {
			var isWeblink = false;
			if (typeof task !== "undefined" && task._data.aspects.contentData.data.objectType === "weblink") {
				isWeblink = true;
			}
			return isWeblink;
		};

		$scope.isWeblinkComplete = function (task) {
			var isWeblinkComplete = false;
			if ($scope.isWebLink(task) && "subType" in task._data.aspects.contentData.data && !!task._data.aspects["atex.WFContentStatus"]) {
				isWeblinkComplete = true;
				//task._data.aspects.contentData.data.webLinkType = $scope.webLinkTypes[task.data.aspects.contentData.data.linkType];
				task._data.aspects.contentData.data.webLinkStatus = task._data.aspects["atex.WFContentStatus"].data.status.name;
			}
			return isWeblinkComplete;
		};

		$scope.isSocialMedia = function (task) {
			var isSocialMedia = false;
			if (typeof task !== "undefined" && task._data.aspects.contentData.data.objectType === "socialmedia") {
				isSocialMedia = true;
			}
			return isSocialMedia;
		};

		$scope.isSocialMediaComplete = function (task) {
			var isSocialMediaComplete = false;
			if ($scope.isSocialMedia(task) && "subType" in task._data.aspects.contentData.data && !!task._data.aspects["atex.WFContentStatus"]) {
				isSocialMediaComplete = true;
				task._data.aspects.contentData.data.socialMediaType = task._data.aspects.contentData.data.subType.charAt(0).toUpperCase() + task._data.aspects.contentData.data.subType.slice(1);
				task._data.aspects.contentData.data.socialMediaStatus = task._data.aspects["atex.WFContentStatus"].data.status.name;
			}
			return isSocialMediaComplete;
		};

		$scope.isAudio = function (task) {
			var isAudio = false;
			if (typeof task !== "undefined" && task._data.aspects.contentData.data.objectType === "audio") {
				isAudio = true;
			}
			return isAudio;
		};

		$scope.isAudioComplete = function (task) {
			var isAudioComplete = false;
			if ($scope.isAudio(task) && "subType" in task._data.aspects.contentData.data && !!task._data.aspects["atex.WFContentStatus"]) {
				isAudioComplete = true;
				task._data.aspects.contentData.data.audioType = task._data.aspects.contentData.data.subType.charAt(0).toUpperCase() + task._data.aspects.contentData.data.subType.slice(1);
				task._data.aspects.contentData.data.audioStatus = task._data.aspects["atex.WFContentStatus"].data.status.name;
			}
			return isAudioComplete;
		};

		$scope.isUserContent = function (task) {
			var isUserContent = false;
			if (task._data.aspects.contentData.data.objectType === "usercontent") {
				isUserContent = true;
			}
			return isUserContent;
		};

		$scope.getAttributesList = function (attrs) {
			var rows = [];
			$scope.attributes.forEach(function (attribute) {
				var content;
				if (attrs && attrs.includes(attribute.id)) {
					content = attribute;
				}
				rows.push(content);
			});

			return rows;
		};

		function getDeadline(str) {
			var date = new Date(str);
			var hours = date.getHours();
			var minutes = date.getMinutes();
			var ampm = hours >= 12 ? 'PM' : 'AM';
			hours = hours % 12;
			hours = hours ? hours : 12; // the hour '0' should be '12'
			minutes = minutes < 10 ? '0' + minutes : minutes;
			var deadline = (date.getMonth() + 1) + '/' + date.getDate() + ", " + hours + ':' + minutes + ' ' + ampm;
			return deadline;
		}

		$scope.isPublEventPresent = function(job) {
			var isPresent = false;
			if (job._data.aspects.contentData.data.objects !== undefined){
				var arr = job._data.aspects.contentData.data.objects;
				for (var i = 0; i < arr.length; i++){
					if (atex.onecms.ObjectUtils.getByPath(job._data.aspects.contentData.data.objects[i], 'data/aspects/atex.dam.standard.Publevents/data/publevents') !== undefined){
						isPresent = true;
					}
				}
			}
			return isPresent;
		};

		$scope.isTvJob = function(job) {
			var isTvJob = false;
			if ($scope.searchedVideo !== undefined && $scope.searchedVideo[job.id] !== undefined){
				return true;
			}
			if (job._data.aspects.contentData.data.tvJob){
				$scope.searchedVideo[job.id] = "Load";
				//$scope.addTvOverlayInfo(job);
				isTvJob = true;
			}
			return isTvJob;
		};

		$scope.hasAuthor = function (job, index) {
			var hasAuthor = false;
			if ($scope.searchedAuthors !== undefined && $scope.searchedAuthors[job.id + index] !== undefined){
				return true;
			}
			if (job.articleData !== undefined && job.articleData.authors !== undefined && job.articleData.authors.length >= index && job.articleData["reporter" + index + "_simple"] === undefined) {
				$scope.searchedAuthors[job.id + index] = "Load";
				$scope.searchedJob.push(job);
				$scope.translateAuthor(job.articleData.authors[index-1],index);
				hasAuthor = true;
			}
			return hasAuthor;
		};


		$scope.translateAuthor = function (idOneCms1,index) {
			if (index === 1){
				return ContentService.getContent({id: idOneCms1.replace("contentid/","")}).then(function (response) {
					$scope.updateVideoReporter(response,1);
				});
			}else{
				return ContentService.getContent({id: idOneCms1.replace("contentid/","")}).then(function (response) {
					$scope.updateVideoReporter(response,2);
				});
			}
		};


		function escapeHtml(html){
			var text = html.replace(/&lt;/g , "<").replace(/&gt;/g , ">").replace(/&quot;/g , "\"").replace(/&#39;/g , "\'").replace(/&amp;/g , "&").replace(/&nbsp;/g, ' ').replace(/\n/g,' ').replace(/\t/g,' ').replace(/<\/?[^>]+(>|$)/g, "").replace(/&rsquo;/g, "'").replace(/&mdash;/g,"—").trim();
			return text;
		}

		$scope.updateVideoReporter = function(response,index){
			for (var i = 0; i < $scope.searchedJob.length; i++){
				var job = $scope.searchedJob[i];
				for(var j = 0; j < job.articleData.authors.length; j++){
					if (job.articleData.authors[j].replace("contentid/","") === response.id){
						job.articleData["reporter" + index + "_simple"] = response.data.aspects.contentData.data.name;
					}
				}
			}
		};

		$scope.hasMMJ = function (job, index) {
			var hasMMJ = false;
			if (!!job.videoData && "mmjName" in job.videoData) {
				if (job.videoData.mmjName !== "") {
					hasMMJ = true;
				}
			}
			return hasMMJ;
		};

		$scope.hasArticleOnTime = function (job) {
			var hasArticleOnTime = false;
			if (!!job.articleData && !!job.articleData.timeState && !!job.articleData.timeState.ontime && job.articleData.timeState.ontime !== 0) {
				hasArticleOnTime = true;
				job._data.aspects.contentData.data.digitalDeadlineLabel = !!job._data.aspects.contentData.data.digitalDeadlineLabel ? job._data.aspects.contentData.data.digitalDeadlineLabel : "Digital Deadline: " + getDeadline(parseInt(job.articleData.timeState.ontime, 10));
			}
			return hasArticleOnTime;
		};

		$scope.hasJobDeadline = function (job) {
			var hasJobDeadline = false;
			if ("digitalDeadline" in job._data.aspects.contentData.data && job._data.aspects.contentData.data.digitalDeadline !== "" && parseInt(job._data.aspects.contentData.data.digitalDeadline, 10) !== 0) {
				hasJobDeadline = true;
				job._data.aspects.contentData.data.digitalDeadlineLabel = !!job._data.aspects.contentData.data.digitalDeadlineLabel ? job._data.aspects.contentData.data.digitalDeadlineLabel : "Digital Deadline: " + getDeadline(parseInt(job._data.aspects.contentData.data.digitalDeadline, 10));
			}
			return hasJobDeadline;
		};

		//returns true if job's article has ontime or job has a digital deadline and is within X hours ago or in the future
		$scope.hasDeadlineInFuture = function (job) {
			var hasDeadlineInFuture = false;
			if ($scope.hasArticleOnTime(job) === true || $scope.hasJobDeadline(job) === true) {
				var deadline = $scope.hasArticleOnTime(job) === true ? new Date(parseInt(job.articleData.timeState.ontime, 10)) : new Date(parseInt(job._data.aspects.contentData.data.digitalDeadline, 10));
				var hrsAgo = $scope.getHoursAgo(4);
				if (deadline >= hrsAgo) {
					hasDeadlineInFuture = true;
				}
			}
			return hasDeadlineInFuture;
		};

		//detect if emtpy class needs appended if deadline sort is selected and job doesn't have a deadline, empty class removes border on ul for empty entry
		$scope.appendEmpty = function (job) {
			var empty = "";
			if (($scope.deadlineSortSelected() && !$scope.hasDeadlineInFuture(job)) || $scope.enterpriseSortSelected() || ($scope.tvSortSelected() && !job.hasVideoTask)) {
				empty = "empty";
			}
			return empty;
		};

		$scope.hasLength = function (job) {
			var hasLength = false;
			if (!!job.articleData && ("length" in job.articleData || "words" in job.articleData)) {
				job.articleData.displayLength = "0";
				if (job.articleData.length !== "") {
					job.articleData.displayLength = job.articleData.length;
					hasLength = true;
				}
				if (job.articleData.words !== "") {
					job.articleData.displayLength = job.articleData.displayLength + " / " + job.articleData.words;
					hasLength = true;
				}
			}
			return hasLength;
		};

		$scope.hasArticleShortTitle = function (job) {
			var hasArticleShortTitle = false;
			if (!!job.articleData && !!job.articleData.teaserTitle && !!job.articleData.teaserTitle.text && $scope.stripHTML(job.articleData.teaserTitle.text).trim() !== "") {
				job.articleData.displayShortHeadline = $scope.stripHTML(job.articleData.teaserTitle.text).trim();
				hasArticleShortTitle = true;
			}
			return hasArticleShortTitle;
		};

		$scope.hasArticleBrief = function (job) {
			var hasArticleBrief = false;
			if (!!job.articleData && !!job.articleData.lead && !!job.articleData.lead.text && $scope.stripHTML(job.articleData.lead.text).trim() !== "") {
				job.articleData.displayBrief = $scope.stripHTML(job.articleData.lead.text).trim();
				hasArticleBrief = true;
			}
			return hasArticleBrief;
		};

		$scope.hasNewsLabel = function (job) {
			var hasNewsLabel = false;
			if (!!job.articleData && !!job.articleData.newsLabel && job.articleData.newsLabel !== "NONE") {
				job.articleData.newsLabel = job.articleData.newsLabel.toUpperCase();
				if (job.articleData.newsLabel === "SPECIALREPORT") {
					job.articleData.newsLabel = "SPECIAL REPORT";
				} else if (job.articleData.newsLabel === "NDFIRST") {
					job.articleData.newsLabel = "FIRST IN NEWSDAY";
				} else if (job.articleData.newsLabel === "NDONLY") {
					job.articleData.newsLabel = "ONLY IN NEWSDAY";
				}
				hasNewsLabel = true;
			}
			return hasNewsLabel;
		};

		$scope.hasNote = function (job) {
			var hasNote = false;
			if (job._data.aspects['atex.WFContentStatus'] && !!job._data.aspects['atex.WFContentStatus'].data.comment && job._data.aspects['atex.WFContentStatus'].data.comment !== "") {
				hasNote = true;
			}
			return hasNote;
		};

		$scope.hasRelated = function (job) {
			var hasRelated = false;
			var tasks = atex.onecms.ObjectUtils.getByPath(job._data.aspects, 'contentData/data/tasks') || [];
			if (tasks.length > 0) {
				hasRelated = true;
			}
			return hasRelated;
		};

		$scope.hasRelevance = function (job) {
			var hasRelevance = false;
			if ('relevance' in job._data.aspects.contentData.data && job._data.aspects.contentData.data.relevance !== "") {
				hasRelevance = true;
				job._data.aspects.contentData.data.relevanceNum = parseInt(job._data.aspects.contentData.data.relevance, 10);
			}
			return hasRelevance;
		};

		$scope.setContentShortCut = function (job) {
			//this only brings back the FIRST instance of matching related content, used for checking if a job has certain related content types
			if (typeof job._data.aspects.contentData.data.objects !== "undefined" && typeof job.articleData === "undefined") {
				for (var i = 0; i < job._data.aspects.contentData.data.objects.length; i++) {
					if (job._data.aspects.contentData.data.objects[i].data.aspects.contentData.data.objectType === "article") {
						job.articleData = job._data.aspects.contentData.data.objects[i].data.aspects.contentData.data;
						job.articleStatus = job._data.aspects.contentData.data.objects[i].data.aspects["atex.WFContentStatus"].data;
					}
					if (job._data.aspects.contentData.data.objects[i].data.aspects.contentData.data.objectType === "video") {
						job.videoData = job._data.aspects.contentData.data.objects[i].data.aspects.contentData.data;
					}
					if (job._data.aspects.contentData.data.objects[i].data.aspects.contentData.data.objectType === "weblink") {
						job.weblinkData = job._data.aspects.contentData.data.objects[i].data.aspects.contentData.data;
					}
				}
			}
			/*if (typeof job._data.aspects.contentData.data.objects !== "undefined" && typeof job.relatedItems === "undefined") {
				job.relatedItems = job._data.aspects.contentData.data.objects;
			}*/
		};

		$scope.setTitle = function (task) {
			if (!!task._data.aspects.contentData.data.teaserTitle && task._data.aspects.contentData.data.objectType === "article") {
				task._data.aspects.contentData.data.displayTitle = $scope.stripHTML(task._data.aspects.contentData.data.teaserTitle.text);
			} else if (!!task._data.aspects.contentData.data.shortHeadline && task._data.aspects.contentData.data.shortHeadline !== "") {
				task._data.aspects.contentData.data.displayTitle = $scope.stripHTML(task._data.aspects.contentData.data.shortHeadline);
			} else if (!!task._data.aspects.contentData.data.mobileHeadline && task._data.aspects.contentData.data.mobileHeadline !== "") {
				task._data.aspects.contentData.data.displayTitle = $scope.stripHTML(task._data.aspects.contentData.data.mobileHeadline);
			} else {
				if (typeof task._data.aspects.contentData.data.headline === "undefined") {
					task._data.aspects.contentData.data.headline = "";
				}
				task._data.aspects.contentData.data.displayTitle = $scope.stripHTML(task._data.aspects.contentData.data.headline);
			}
		};

		$scope.setColor = function (task) {
			task.labelColor = "";
			var status;
			if ('atex.WebContentStatus' in task._data.aspects) {
				status = $scope.getStatusFromId(task._data.aspects['atex.WebContentStatus'].data.status.statusID);
			}else{
				status = $scope.getStatusFromId('draft');
			}
			if (!status){
				status = $scope.getStatusFromId('inProgress');
                if (!status) {
                    return;
                }
			}
			task.labelColor = "background: " + status.color + ";";
			if (status.color === "#FFFF00" || status.color === "#FFFF33" || status.color === "#66FF33" || status.color === "#FFFFFF") {
				task.labelColor = task.labelColor + " color: #000;";
			}else if (status.color === "#FFFFFF") {
				task.labelColor = task.labelColor + " border: solid 1px #999;";
			}else {
				task.labelColor = task.labelColor + " color: #000;";
			}
		};

		$scope.getStatus = function (task) {
			var status;
			if (task._data.aspects['atex.WFContentStatus']){
				var limit = 150;
				status = task._data.aspects['atex.WFContentStatus'].data.status;
				if (status.color === undefined && status.statusID !== undefined){
					status = $scope.getWFStatusFromId(status.statusID);
				}
				var color = atex.dam.AngularUtils.textColorOnBgColorByParam(status.color,limit);
				status['text-color'] = color;
			}
			return status;
		};

		$scope.setStar = function (index, job) {
			var star = "fa fa-star-o";
			if (index < job._data.aspects.contentData.data.relevanceNum) {
				star = "fa fa-star";
			}
			return star;
		};

		$scope.stripAuthor = function (author) {
			return author.substring(0, author.indexOf("/"));
		};

		$scope.stripHTML = function (html) {
			var tmp = document.createElement("DIV");
			tmp.innerHTML = html;
			return tmp.textContent || tmp.innerText || "";
		};

		//return tomrrow's date in "yyyy-mm-ddT00:00:00.000Z" format
		$scope.getTMRDate = function () {
			var tmr = new Date();
			tmr.setDate(tmr.getDate() + 1);
			tmr.setHours(0, 0, 0, 0);
			return tmr;
		};

		//return tomorrow's date in string format
		$scope.getTMRStr = function () {
			var tmr = $scope.getTMRDate();
			tmr = tmr.toJSON();
			return tmr;
		};

		$scope.getHoursAgo = function (hours) {
			var hrAgo = new Date();
			hrAgo.setHours(hrAgo.getHours() - hours);
			return hrAgo;
		};

		//collapse job
		$scope.hideRelated = function (job) {
			job.show = false;
		};

		//on new date selection
		$scope.onStartDateChange = function (pDate) {
			var startdate = new Date($("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val());
			if (startdate > new Date($("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val())){
				$("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val($("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val());
			}
		};

		//on new date selection
		$scope.onSegmentStartDateChange = function (pDate) {
			var startdate = new Date($("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val());
			if (startdate > new Date($("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val())){
				$("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val($("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val());
			}
		};

		//on new date selection
		$scope.onEndDateChange = function (pDate) {
			if ($("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val() !== ''){
				var enddate = new Date($("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val());
				if (enddate < new Date($("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val())){
					$("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val($("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val());
				}
			}
		};

		//on new date selection
		$scope.onSegmentEndDateChange = function (pDate) {
			if ($("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val() !== ''){
				var enddate = new Date($("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val());
				if (enddate < new Date($("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val())){
					$("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val($("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val());
				}
			}
		};

		$scope.formatDate = function (selected) {
			var date = new Date(selected);
			date.setHours(0, 0, 0, 0);
			return date.toJSON();
		};

		$scope.normalizeDateToUTC = function (dateValue, start) {
			var dateArray = [];
			var res;
			if (dateValue.includes("-")){
				dateArray = dateValue.split("-");
			}else if(dateValue.includes("/")){
				dateArray = dateValue.split("/");
			}
			if (dateArray.length > 0){
				if (start){
					res = (new Date(Date.UTC(dateArray[2],dateArray[0]-1,dateArray[1],0,0,0,0))).toJSON();
				}else{
					res = (new Date(Date.UTC(dateArray[2],dateArray[0]-1,dateArray[1],23,59,59,59))).toJSON();
				}
			}
			return res;
		};

		//sort desk dropdown toggle
		$scope.toggleDropdown = function (entries, event) {
			if ($(event.target).is("#inputState") || $(event.target).is("#inputState span")) {
				$("#dam-list-budget-view #inputState").toggleClass("active");
				if ($("#dam-list-budget-view #inputState").hasClass("active")) {
					$("#dam-list-budget-view #inputState span").removeClass("fa-arrow-down").addClass("fa-arrow-up");
				} else {
					$("#dam-list-budget-view #inputState span").removeClass("fa-arrow-up").addClass("fa-arrow-down");
				}
			}
		};

		$scope.checkAllDesks = function () {
			$("#dam-list-budget-view #inputState input").each(function () {
				$(this)[0].checked = true;
			});
		};

		$scope.unCheckAllDesks = function () {
			$("#dam-list-budget-view #inputState input").each(function () {
				$(this)[0].checked = false;
			});
		};

		//desk checkbox toggled
		$scope.deskToggled = function (entry) {
			var index = $scope.desks.indexOf(entry);
			if (entry.value === "All" && $("#dam-list-budget-view #inputState input:eq(0)")[0].checked === true) {
				//if all desk is checked, check all other checkboxes
				$scope.checkAllDesks();
			} else if (entry.value === "All" && $("#dam-list-budget-view #inputState input:eq(0)")[0].checked === false) {
				//if all desk is unchecked, uncheck all other checkboxes
				$scope.unCheckAllDesks();
			} else if ($("#dam-list-budget-view #inputState input:eq(" + index + ")")[0].checked === false) {
				//if a checkbox is unchecked, uncheck all desk option
				$("#dam-list-budget-view #inputState input:eq(0)")[0].checked = false;
			}
		};

		//on new sort selection
		//    $scope.onSortChange = function(selected) {
		//        $scope.selectedSort = selected;
		//        if (selected.label === "Digital Deadline") {
		//            $scope.deadlineSort = true;
		//        } else {
		//            $scope.deadlineSort = false;
		//        }
		//    };

		//return whether deadline sort is selected
		$scope.deadlineSortSelected = function () {
			var deadlineSortSelected = false;
			if ($scope.sort && $scope.sort[$("#sortState").val()] && $scope.sort[$("#sortState").val()].label === "Digital Deadline") {
				deadlineSortSelected = true;
			}
			return deadlineSortSelected;
		};

		$scope.segmentSortSelected = function () {
			var segmentSortSelected = false;
			if ($scope.sort && $scope.sort[$("#sortState").val()] && $scope.sort[$("#sortState").val()].label === "Segments") {
				segmentSortSelected = true;
			}
			return segmentSortSelected;
		};

		$scope.hoverEdit = false;
		$scope.hoverIn = function(entry){
			entry.hoverEdit = true;
		};

		$scope.hoverOut = function(entry){
			entry.hoverEdit = false;
		};

		$scope.getPopOverText = function(job){
			var msg = "";
			if (job._data.aspects.contentData.data.objects !== undefined){
				var arr = job._data.aspects.contentData.data.objects;
				for (var i = 0; i < arr.length; i++){
					var publevents = atex.onecms.ObjectUtils.getByPath(job._data.aspects.contentData.data.objects[i], 'data/aspects/atex.dam.standard.Publevents/data/publevents');
                    if (publevents !== undefined && publevents.length > 0) {
						var dateStr = "";
						if (publevents.length > 0 && publevents[0].pubdate !== undefined){
							dateStr = new Date(parseInt(publevents[0].pubdate)).toDateString();
							msg = "Paginated on " + dateStr  + " in page " + (publevents[0].page !== undefined ? publevents[0].page : "")  + " of " + (publevents[0].pub !== undefined ? publevents[0].pub : "") + "" + (publevents[0].pagelevel !== undefined ? " " +publevents[0].pagelevel : "");
							msg = msg + "" + (publevents[0].edition !== undefined ? " " +publevents[0].edition : "") + "" + (publevents[0].zone !== undefined ? " " +publevents[0].zone : "") + "" + (publevents[0].section !== undefined ? " " +publevents[0].section : "") + "";
						}
					}
				}
			}
			return msg;
		};

		$scope.enterpriseSortSelected = function () {
			var enterpriseSortSelected = false;
			if ($scope.sort && $scope.sort[$("#sortState").val()] && $scope.sort[$("#sortState").val()].label === "Planning") {
				enterpriseSortSelected = true;
			}
			return enterpriseSortSelected;
		};

		$scope.tvSortSelected = function () {
			var tvSortSelected = false;
			if ($scope.sort && $scope.sort[$("#sortState").val()] && $scope.sort[$("#sortState").val()].label === "Newsday TV"){
				tvSortSelected = true;
			}
			return tvSortSelected;
		};

		$scope.getLabel = function (data) {
			var label = (!!data.objectType) ? data.objectType : "";
			$scope.references.forEach(function(reference) {
				if (reference.value === data.subType) {
					label = reference.label;
				}
			});
			return label;
		};

		$scope.renderHtml = function (configurationHtml) {
				var html = configurationHtml;
				var loadMoreButton = document.getElementById("laodMoreResultBtn");
				if (html && loadMoreButton !== null) {
					var linkFn = $compile(html);
					var content = linkFn($scope);
					var element = angular.element('#budget-list-template');
					element.replaceWith(content);
				}
		};

		//on filter re-applying
		$scope.onSubmit = function () {
			$("#dam-list-budget-view #inputState").removeClass("active").find("span").removeClass("fa-arrow-up").addClass("fa-arrow-down");
			$scope.query = DamSearchService.getCurrentAdvQuery();
			//$scope.query.name = "job";
			//$scope.query.types = ["job"];
			$scope.query.fields = [{
				"key": "atex_desk_objectType",
				"values": [
					"job"
				],
				"operator": false,
				"extraValues": [],
				"type": "LIST",
				"useId": false,
				"useValue": false,
				"useBoolean": false,
				"split": false,
				"queryOperator": ""
			}];
			$scope.subheadTypes = []; //store desk title lab labels for each new desk type in result
			$scope.subheadIds = []; //store list of job ids for title label
			$scope.tvDateGroups = []; //store list of job ids for title label
			$scope.overlayTaskInfo = [];
			taskPromises = [];
			if (typeof $("#dam-list-budget-view input[placeholder='Optional Search']").val() !== "undefined") {
				$scope.query.name = $scope.query.fullText = $("#dam-list-budget-view input[placeholder='Optional Search']").val();
			}
			if (!$scope.query.publishingTime) {
				$scope.query.publishingTime = [];
			}

			$scope.query.tvPublishingTime = [];
			$scope.query.sortValue = $scope.selectedSort.value;
			if ($scope.sort[$("#sortState").val()]) {
				$scope.query.sortOrderValue = $scope.sort[$("#sortState").val()].sort;
			}
			if ($scope.deadlineSortSelected() === true) {
				$scope.query.enterprise = '';
				$scope.query.publishingTime[0] = $scope.formatDate($("#dam-list-budget-view input[date-picker-id='budgetDeadlineDate']").val());
				var dDate2 = new Date($scope.formatDate($("#dam-list-budget-view input[date-picker-id='budgetDeadlineDate']").val()));
				dDate2.setDate(dDate2.getDate() + 10);
				dDate2.setHours(0, 0, 0, 0);
				$scope.query.publishingTime[1] = dDate2.toJSON();
			} else if ($scope.enterpriseSortSelected() === true || $scope.tvSortSelected()) {
				$scope.query.enterprise = 'enterpriseBudget_atex_desk_b:(true)';
				$scope.query.publishingTime = [];
				//sorting is set in js/dam/app.js
			}  else if ($scope.segmentSortSelected() === true) {
				$scope.query.enterprise = '';
				$scope.query.tvPublishingTime[0] = $scope.normalizeDateToUTC($("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val(),true);
				$scope.query.tvPublishingTime[1] = $scope.normalizeDateToUTC($("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val(),true);
				if (!$scope.query.tvPublishingTime[1]){
					$scope.query.tvPublishingTime[1] = "*";
				}
				$scope.query.publishingTime = [];
			}else {
				$scope.query.enterprise = '';
				if($("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val()){
					$scope.query.publishingTime[0] = $scope.normalizeDateToUTC($("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val(), true);
				}
				if($("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val()){
					$scope.query.publishingTime[1] = $scope.normalizeDateToUTC($("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val(), false);
				}

			}
			//console.log("QUERY ",   $scope.query);

			$scope.query.colorCoding = [];
			if ($("#dam-list-budget-view #inputState input").first().length > 0 && $("#dam-list-budget-view #inputState input").first()[0].checked === true) {
				//all desks selected
			} else {
				$("#dam-list-budget-view #inputState input").each(function () {
					if ($(this)[0].checked === true) {
						$scope.query.colorCoding.push($(this).data("val").toString());
					}
				});
			}
			//console.log("query ", $scope.query);
			$scope.query.budgetView = true;
			$scope.query.timeZone = "America/New_York";
			if ($scope.segmentSortSelected()){
				$scope.query.tvJob = true;
			}else{
				$scope.query.tvJob = false;
			}
			DamSearchService.advancedSearch($scope.query, $scope.setExtraInfo());
		};

		//retrieve related tasks, set an array of timers to check locks on each expanded job
		$scope.poll = function (job) {

			if (job && !$scope.overlayTaskInfo.includes(job.id)){
				$scope.retivingTaskInfo = true;
				var tasks = atex.onecms.ObjectUtils.getByPath(job, '_data/aspects/contentData/data/tasks') || [];
				$scope.overlayTaskInfo.push(job.id);

				taskPromises.push(DamTaskService.tasks(tasks).then(function (results) {
					job._data.aspects.contentData.data.objects = results;
					$scope.updateSelection(results, job);
				}));
				$q.all(taskPromises).then(function () {
					$scope.retivingTaskInfo = false;
				});
			}
		};

		//return timestamp in yyyy/mm/dd hh:mm:ss format
		$scope.getDateTime = function () {
			var now = new Date();
			var year = now.getFullYear();
			var month = now.getMonth() + 1;
			var day = now.getDate();
			var hour = now.getHours();
			var minute = now.getMinutes();
			var second = now.getSeconds();
			if (month.toString().length === 1) {
				month = '0' + month;
			}
			if (day.toString().length === 1) {
				day = '0' + day;
			}
			if (hour.toString().length === 1) {
				hour = '0' + hour;
			}
			if (minute.toString().length === 1) {
				minute = '0' + minute;
			}
			if (second.toString().length === 1) {
				second = '0' + second;
			}
			var dateTime = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
			return dateTime;
		};

		//reset search query
		$scope.resetQuery = function (query) {
			query.publishingTime = [$scope.getTMRStr(), $scope.getTMRStr()];
			query.tvPublishingTime = [$scope.getTMRStr(), $scope.getTMRStr()];
			//query.publishingTime = [];
			query.colorCoding = [];
			//query.name = "job";
			query.sortValue = $scope.selectedSort.value;
			//query.types = ["job"];
			query.fields = [{
				"key": "atex_desk_objectType",
				"values": [
					"job"
				],
				"operator": false,
				"extraValues": [],
				"type": "LIST",
				"useId": false,
				"useValue": false,
				"useBoolean": false,
				"split": false,
				"queryOperator": ""
			}];
			query.fullText = "";
			query.enterprise = '';
			delete query.assignees;
			delete query.creationDate;
			delete query.editions;
			delete query.iconCoding;
			delete query.insertionDate;
			delete query.pages;
			delete query.sections;
			delete query.slug;
			query.solrQueryString = undefined;
			delete query.sortOrderValue;
			delete query.statusList;
			delete query.urgency;
			delete query.viewMode;
			query._type = "atex.dam.standard.Query";
			delete query.byline;
			delete query.isDynamic;
			delete query.isEmbargoed;
			delete query.isNotEngaged;
			delete query.isWebPublished;
			delete query.resources;
			delete query.includeTrash;
			return query;
		};

		//set updated timestamp for search
		$scope.setExtraInfo = function () {
			var ts = Date.now();
			DamSearchService.setLastQueryStartTs(ts);
			var extraInfo = {
				queryTs: ts,
				viewMode: undefined,
				type: undefined
			};
			return extraInfo;
		};

		//reset dates in each datepicker
		$scope.resetDates = function () {
			var d = new Date();
			var dTv = new Date();
			d.setDate(d.getDate() + 1);
			var defaultValue = (d.getMonth() +1).toString().padStart(2,"0") + "/" +  (d.getDate()).toString().padStart(2,"0") + "/" + d.getFullYear();
			var defaultValueTv = (dTv.getMonth() +1).toString().padStart(2,"0") + "/" +  (dTv.getDate()).toString().padStart(2,"0") + "/" + dTv.getFullYear();
			var d2 = new Date();
			d2.setDate(d2.getDate());
			var defaultValue2 = (d2.getMonth() +1).toString().padStart(2,"0") + "/" +  (d2.getDate()).toString().padStart(2,"0") + "/" + d2.getFullYear();
			$scope.pDate = defaultValue;
			$scope.pDate2 = defaultValue;
			$scope.pDateTv = defaultValueTv;
			//$scope.pDateTv2 = defaultValueTv;
			$scope.dDate = defaultValue2;
			$("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val($scope.pDate);
			$("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val($scope.pDate2);
			$("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val($scope.pDateTv);
			$("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val($scope.pDateTv2);
			$("#dam-list-budget-view input[date-picker-id='budgetDeadlineDate']").val($scope.dDate);
		};


		//reset dates in each datepicker
		$scope.initDates = function () {
			var d = new Date();
			var dTv = new Date();
			d.setDate(d.getDate() + 1);
			var defaultValue = (d.getMonth() +1).toString().padStart(2,"0") + "/" +  (d.getDate()).toString().padStart(2,"0") + "/" + d.getFullYear();
			var defaultValueTv = (dTv.getMonth() +1).toString().padStart(2,"0") + "/" +  (dTv.getDate()).toString().padStart(2,"0") + "/" + dTv.getFullYear();
			var d2 = new Date();
			d2.setDate(d2.getDate());
			var defaultValue2 = (d2.getMonth() +1).toString().padStart(2,"0") + "/" +  (d2.getDate()).toString().padStart(2,"0") + "/" + d2.getFullYear();
			$scope.pDate = defaultValue;
			$scope.pDate2 = defaultValue;
			$scope.pDateTv = defaultValueTv;
			$scope.pDateTv2 = undefined;
			$scope.dDate = defaultValue2;
			if ($("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val() === ""){
				$("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val($scope.pDate);
			}
			if ($("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val() === ""){
				$("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val($scope.pDate2);
			}
			if ($("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val() === ""){
				$("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val($scope.pDateTv);
				$("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val("");
			}
			if ($("#dam-list-budget-view input[date-picker-id='budgetDeadlineDate']").val() === ""){
				$("#dam-list-budget-view input[date-picker-id='budgetDeadlineDate']").val($scope.dDate);
			}
			$("#budgetStartDate").on("dp.change", function (e) {
				$scope.onStartDateChange($("#budgetStartDate").val());
			});
			$("#budgetSegmentStartDate").on("dp.change", function (e) {
				$scope.onSegmentStartDateChange($("#budgetSegmentStartDate").val());
			});
			$("#budgetEndDate").on("dp.change", function (e) {
				$scope.onEndDateChange($("#budgetEndDate").val());
			});
			$("#budgetSegmentEndDate").on("dp.change", function (e) {
				$scope.onSegmentEndDateChange($("#budgetSegmentEndDate").val());
			});
		};

		//redo another search with all defaults
		$scope.reset = function () {
			$("#dam-list-budget-view #inputState").removeClass("active").find("span").removeClass("fa-arrow-up").addClass("fa-arrow-down");
			$scope.checkAllDesks();
			//        $("#dam-list-budget-view select[ng-model='selectedSort'] option:eq(0)").prop("selected", true);
			$("#dam-list-budget-view input[placeholder='Optional Search']").val("");
			$scope.resetDates();
			$scope.query.colorCoding = [];
			$scope.overlayTaskInfo = [];
			taskPromises = [];
			//$scope.query = DamSearchService.getCurrentAdvQuery();
			$scope.query = $scope.resetQuery($scope.query);

		};

		//expand job
		$scope.showRelated = function (job) {
			job.show = true;
		};

		//trigger click on first job to show in preview
		$scope.triggerFirstPreview = function (index, entry) {
			if (index === 0) {
				$timeout(function () {
					angular.element("#dam-list-budget-view .list-group-item:eq(0)").trigger('click');
				}, 0);
			}
		};

		//maping to task objects based on task ids in job
		$scope.updateSelection = function (tasks, job) {
			tasks.map(function (task) {
				$scope.setTitle(task);
				$scope.setColor(task);
				if ($scope.selected) {
					$scope.selected.forEach(function (selection, key) {
						if (selection.id === task.id) {
							$scope.selected[key] = task;

						}
					});
				}
				//$scope.checkLock(task);
				if (task.data.aspects.contentData.data.objectType === "video"){
					job.hasVideoTask = true;
					if ($scope.segmentSortSelected()){
						$scope.overlayTvVideoInfo(task, job);
					}
				}
			});
		};

		$scope.hasJobVideoTask = function (job) {
			return !$scope.tvSortSelected() || ($scope.tvSortSelected() && job.hasVideoTask);
		};

		$rootScope.$on('dam:justifyThumbs', function(msg, redoFullJustification) {
			if (!$scope.renderedHtml && $scope.htmlTemplate) {
				$scope.renderedHtml = true;
				$scope.renderHtml($scope.htmlTemplate);
			}
		});


		//event that triggers when entries change
		$scope.watchEntries = function () {
			$scope.$watch("$parent.$parent.$parent.entries", function (entries) {
				$scope.subheadTypes = [];
				$scope.tvDateGroups = [];
				$scope.subheadIds = [];
				$scope.searchedJob = [];
				$scope.searchedAuthors = [];
				$scope.overlayTaskInfo = [];
				taskPromises = [];
				$scope.searchedVideo = [];
				for (var i = 0; i < entries.length; i++) {
					$scope.isNewSubHead(entries[i]);
				}
			});
		};

		/************** initial setup **************/
		//initial setup
		$scope.init = function () {
			$scope.references = ([
				{"label": "Article", "value": "article"},
				{"label": "Images", "value": "images"},
				{"label": "Video", "value": "video"},
				{"label": "Weblink", "value": "weblink"},
				{"label": "Animation", "value": "animation"},
				{"label": "Audio", "value": "audio"},
				{"label": "Social Media", "value": "socialmedia"},
				{"label": "Story Gallery", "value": "storygallery"},
				{"label": "Article", "value": "Article"},
				{"label": "Special article", "value": "specialArticle"},
				{"label": "Column", "value": "Column"},
				{"label": "Review", "value": "Review"},
				{"label": "Editorial", "value": "Editorial"},
				{"label": "Letter", "value": "Letter"},
				{"label": "Newsletter", "value": "Newsletter"},
				{"label": "Opinion", "value": "Opinion"},
				{"label": "Accordion", "value": "accordion"},
				{"label": "HTML article", "value": "htmlArticle"},
				{"label": "Article photos", "value": "articlePhotos"},
				{"label": "Photo gallery", "value": "photoGallery"},
				{"label": "Photolist", "value": "photoList"},
				{"label": "Collage", "value": "collage" },
				{"label": "Story gallery", "value": "storyGallery"},
				{"label": "Mixed media", "value": "mixedMedia"},
				{"label": "Grid view", "value": "gridView"},
				{"label": "Video", "value": "video"},
				{"label": "Live video", "value": "live"},
				{"label": "Enhanced video", "value": "eVid"},
				{"label": "YouTube", "value": "youtube"},
				{"label": "SendToNews", "value": "sendToNews"},
				{"label": "MMJ Video", "value": "MMJVideo"},
				{"label": "Documentary", "value": "documentary"},
				{"label": "Video Essay", "value": "videoessay"},
				{"label": "Reporter Debrief Video", "value": "reporterdebriefvideo"},
				{"label": "Nat Sound Video", "value": "natsoundvideo"},
				{"label": "B-roll Show", "value": "brollshow"},
				{"label": "Podcast", "value": "podcast"},
				{"label": "Clip", "value": "clip" },
				{"label": "Interactive project", "value": "project"},
				{"label": "Database", "value": "database"},
				{"label": "Web page", "value": "webpage"},
				{"label": "Facebook Live", "value": "facebookLive"},
				{"label": "Facebook Square Cut", "value": "facebookSquareCut"},
				{"label": "Instagram Story", "value": "instagram"},
				{"label": "Instagram Square Cut", "value": "instagramSquareCut"},
				{"label": "Instagram Reel", "value": "instagramReel"},
				{"label": "IGTV", "value": "igtv"}
			]);

			$scope.attributes = [];
			//$scope.timeouts = [];
			$scope.subheadTypes = [];
			$scope.tvDateGroups = [];
			$scope.subheadIds = [];
			$scope.desks = configuration.getDesks();
			ContentService.getContent({id: "atex.configuration.desk.budget-view"}).then(function (configuration) {
				if (configuration){
					if (configuration.data.aspects.contentData.data.json){
						$scope.htmlTemplate = JSON.parse(configuration.data.aspects.contentData.data.json)['budget-view'][0].config['budget-view'].html;
					}
					if (configuration.data.aspects.contentData.data.json){
						$scope.sort = JSON.parse(configuration.data.aspects.contentData.data.json)['budget-view'][0].config['budget-view']['budget-sort'];
						$scope.selectedSort = $scope.sort[0];
					}
				}
				var d = new Date();
				d.setDate(d.getDate() + 1);
				var defaultValue = (d.getMonth() +1).toString().padStart(2,"0") + "/" +  (d.getDate()).toString().padStart(2,"0") + "/" + d.getFullYear();
				var d2 = new Date();
				d2.setDate(d2.getDate());
				var defaultValue2 = (d2.getMonth() +1).toString().padStart(2,"0") + "/" +  (d2.getDate()).toString().padStart(2,"0") + "/" + d2.getFullYear();
				$scope.pDate = defaultValue;
				$scope.pDate2 = defaultValue;
				$scope.dDate = defaultValue2;
				$scope.reset();
				$timeout(function() {
					$scope.onSubmit();
				});
			});
		};

		$scope.query = DamSearchService.getCurrentAdvQuery();
		$scope.query.budgetView = true;
		$scope.query.timeZone = "America/New_York";
		ContentService.getContent({id: "atex.configuration.desk.budget-view"}).then(function (configuration) {
			if (configuration){
				if (configuration.data.aspects.contentData.data.json){
					$scope.htmlTemplate = JSON.parse(configuration.data.aspects.contentData.data.json)['budget-view'][0].config['budget-view'].html;
				}
				if (configuration.data.aspects.contentData.data.json){
					$scope.sort = JSON.parse(configuration.data.aspects.contentData.data.json)['budget-view'][0].config['budget-view']['budget-sort'];
					$scope.selectedSort = $scope.sort[0];
				}
			}
			$scope.init();
		});
		if ($("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val()){
			$scope.query.publishingTime[0] = $scope.normalizeDateToUTC($("#dam-list-budget-view input[date-picker-id='budgetStartDate']").val(),true);
		}
		if($("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val()){
			$scope.query.publishingTime[1] = $scope.normalizeDateToUTC($("#dam-list-budget-view input[date-picker-id='budgetEndDate']").val(),false);
		}

		if ($("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val()){
			$scope.query.tvPublishingTime[0] = $scope.normalizeDateToUTC($("#dam-list-budget-view input[date-picker-id='budgetSegmentStartDate']").val(),true);
		}
		if($("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val()){
			$scope.query.tvPublishingTime[1] = $scope.normalizeDateToUTC($("#dam-list-budget-view input[date-picker-id='budgetSegmentEndDate']").val(),false);
		}
	}]);
